export const appName = process.env.REACT_APP_WEB_NAME || "DEMO";
export const appNameGD = process.env.REACT_APP_WEB_NAME_GD || "DEMO";

export const webName = process.env.REACT_APP_WEB_NAME || "飛龍娛樂城";
export const webNameGD = process.env.REACT_APP_WEB_NAME_GD || "金仁娛樂城";
export const brandName = process.env.REACT_APP_BRAND_NAME || "DS88";
export const brandNameGD = process.env.REACT_APP_BRAND_NAME_GD || "GD88";
export const domainName = process.env.REACT_APP_DOMAIN_NAME || "ds88";
export const domainNameGD = process.env.REACT_APP_DOMAIN_NAME_GD || "gd88";
export const chineseName = process.env.REACT_APP_CHINESE_NAME || "飛龍";
export const chineseNameGD = process.env.REACT_APP_CHINESE_NAME_GD || "金仁";
